import { emptySplitApi } from "./empty-split-api";
import { Notification, NotificationFilters } from "./types/notifications";

const NOTIFICATIONS_QUERY =
  "{id,type,title,description,created_at,is_read,extra,is_active,clinic{id,name,timezone}}";

type UnreadCountsResponse = Record<number, number>;

export const notificationsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<Notification[], NotificationFilters>({
      query: ({ is_active = true, ...filters }) => ({
        url: `/notifications/`,
        params: { ...filters, query: NOTIFICATIONS_QUERY, is_active }
      }),
      providesTags: ["Notifications"]
    }),
    getUnreadCounts: builder.query<
      UnreadCountsResponse,
      Pick<NotificationFilters, "provider" | "clinic">
    >({
      query: (filters) => ({
        url: `/notifications/unread-counts/`,
        params: { ...filters, is_active: true }
      }),
      providesTags: ["NotificationUnreadCounts"]
    }),
    readAllNotifications: builder.mutation<void, number>({
      query: (staff_member_id) => ({
        method: "PATCH",
        url: `/notifications/read/`,
        body: { staff_member_id }
      }),
      invalidatesTags: ["Notifications", "NotificationUnreadCounts"]
    }),
    updateNotifications: builder.mutation<
      void,
      { id: number; is_read?: boolean; is_active?: boolean }
    >({
      query: ({ id, is_read, is_active }) => ({
        url: `/notifications/${id}/`,
        method: "PATCH",
        body: {
          is_active,
          is_read
        }
      }),
      invalidatesTags: ["Notifications", "NotificationUnreadCounts"]
    })
  })
});

export const {
  useGetNotificationsQuery,
  useGetUnreadCountsQuery,
  useUpdateNotificationsMutation,
  useReadAllNotificationsMutation
} = notificationsApi;
